// libraries
import clsx from 'clsx'

// components
import RoundedBox from '/react4xp/components/RoundedBox'
import Image from '/react4xp/components/Image'
import Link from '/react4xp/components/Link'

// utils
import { firstChar, tel, mailto } from '/react4xp/utils/functions'

// types
export interface ContactCardProps {
    className?: string
    color?: 'green-light' | 'beige'
    image?: {
        src?: string
        alt?: string
    }
    title?: string
    position?: string
    location?: string
    tag?: {
        label?: string
        href?: string
        external?: boolean
    }
    tag2?: {
        label?: string
        href?: string
        external?: boolean
    }
    phone?: {
        label?: string
        phone?: string
    }
    email?: {
        label?: string
        email?: string
    }
    href?: {
        label?: string
        href?: string
        external?: boolean
    }
}

// css
import './index.scss'

export default function ContactCard({
    className,
    color,
    image,
    title,
    position,
    location,
    tag,
    tag2,
    phone,
    email,
    href
}: ContactCardProps) {
    return (
        <RoundedBox
            className={clsx(
                'contact-card-component',
                href && 'contact-card-component--href',
                className
            )}
            bgColor={color}
        >
            <div className='contact-card-component__flex'>

                <div className='contact-card-component__image'>

                    {href && (
                        <a
                            href={href.href}
                            target={href.external ? '_blank' : undefined}
                            rel={href.external ? 'noopener noreferrer' : undefined}
                            className='contact-card-component__image-link'
                        />
                    )}

                    {image ? (
                        <Image
                            src={{
                                src: image.src || '',
                                width: 250,
                                height: 250
                            }}
                            alt={image.alt}
                            sizes='(max-width: 250px) 100vw, 250px'
                            lazyLoad
                            className='cover'
                        />
                    ) : (
                        <p className='uppercase h1'>
                            {firstChar(title || '')}
                        </p>
                    )}
                </div>

                <div className='contact-card-component__content'>

                    {title && (
                        href ? (
                            <a
                                href={href.href}
                                target={href.external ? '_blank' : undefined}
                                rel={href.external ? 'noopener noreferrer' : undefined}
                                className='h3'
                            >
                                {title}
                            </a>
                        ) : (
                            <h3 className='h3'>
                                {title}
                            </h3>
                        )
                    )}

                    {(position || location) && (    
                        <div className='contact-card-component__info'>

                            {position && (
                                <p className='body'>
                                    {position}
                                </p>
                            )}

                            {location && (
                                <p className='body'>
                                    {location}
                                </p>
                            )}
                            
                        </div>
                    )}

                    {(tag?.label || tag2?.label) && (
                        <div className='contact-card-component__tags'>
                            {tag?.label && (
                                <a
                                    href={tag.href}
                                    className='contact-card-component__tag'
                                    target={tag.external ? '_blank' : undefined}
                                    rel={tag.external ? 'noopener noreferrer' : undefined}
                                >
                                    {tag.label}
                                </a>
                            )}

                            {tag2?.label && (
                                <a
                                    href={tag2.href}
                                    className='contact-card-component__tag'
                                    target={tag2.external ? '_blank' : undefined}
                                    rel={tag2.external ? 'noopener noreferrer' : undefined}
                                >
                                    {tag2.label}
                                </a>
                            )}
                        </div>
                    )}
                    
                    {(phone || email) && (
                        <div className='contact-card-component__links'>

                            {phone && (
                                <Link
                                    label={{
                                        noUnderline: phone.label,
                                        underline: phone.phone
                                    }}
                                    icon={{
                                        type: 'phone',
                                        iconFirst: true
                                    }}
                                    href={tel(phone.phone || '')}
                                    className='body-small'
                                />
                            )}

                            {email && (
                                <Link
                                    label={{
                                        underline: email.label
                                    }}
                                    icon={{
                                        type: 'envelope',
                                        iconFirst: true
                                    }}
                                    href={mailto(email.email || '')}
                                    className='body-small'
                                />
                            )}

                        </div>
                    )}

                </div>

                {href && (
                    <div className='contact-card-component__href'>
                        <Link
                            label={{
                                underline: href.label
                            }}
                            href={href.href}
                            isExternal={href.external}
                            icon={{
                                type: 'arrow-right'
                            }}
                            className='body-small'
                        />
                    </div>    
                )}
                
            </div>
        </RoundedBox>
    )
}